// extracted by mini-css-extract-plugin
export default {"wrapper":"spiner_wrapper__2JN-v","loader":"spiner_loader__VoVdg"};